import React, { useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { changePasswordSchema } from "../utils/schema";
import ErrorMessage from "../components/ErrorMessage";
import { pageRoutes } from "../routes/pageRoutes";
import { changePassword } from "../redux/action/authAction";
import Loader from "../components/other/Loader";

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { isToggle , isLoading} = useSelector((state) => state.authReducer);
  const [eyes, setEyes] = useState({
    eye1: false,
    eye2: false,
    eye3: false,
  });

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const handleChangePassworrd = (values, actions) => {
    const  callback = (response) =>{
      if(response.success){
        navigate(pageRoutes?.profile)
        actions.resetForm();
      }else {
        actions.resetForm();
      }
    };
    dispatch(changePassword({payload : values, callback}))
  };

if(isLoading){
  return <Loader/>
}

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />
          <div class="ct_inner_dashbaord_main">
            <div class="ct_white_bg ct_mt_28 py-4">
              <div class="ct_px_46">
                <div class="d-flex align-items-center justify-content-between gap-2 mb-5 flex-wrap">
                  <a
                    href="javascript:void(0)"
                    onClick={() => navigate(-1)}
                    class="ct_back_text ct_fs_18"
                  >
                    <i class="fa-solid fa-arrow-left"></i>
                    <span> Back</span>
                  </a>
                  <h4 class="ct_fs_22 ct_ff_roboto ct_fw_600 mx-auto mb-0">
                    Change Password
                  </h4>
                </div>

                <Formik
                  initialValues={initialValues}
                  validationSchema={changePasswordSchema}
                  onSubmit={(values, actions) => {
                    handleChangePassworrd(values,actions);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <form>
                      <div class="row">
                        <div class="col-lg-6 mx-auto">
                          <div class="form-group  mb-4">
                            <label
                              for=""
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <span class="ct_fw_600">Current Password</span>
                            </label>
                            <div class="position-relative">
                              <input
                                className="form-control ct_input ct_ff_roboto"
                                placeholder="Enter current password"
                                type={eyes.eye1 ? "text" : "password"}
                                value={values?.currentPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="currentPassword"
                              />
                              <i
                                style={{ cursor: "pointer" }}
                                class={`fa-regular ct_eye_top ${
                                  eyes.eye1 ? "fa-eye" : "fa-eye-slash"
                                } `}
                                onClick={() =>
                                  setEyes({ ...eyes, eye1: !eyes.eye1 })
                                }
                              ></i>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="currentPassword"
                            />
                          </div>
                          <div class="form-group  mb-4">
                            <label
                              for=""
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <span class="ct_fw_600 ">New Password</span>
                            </label>
                            <div class="position-relative">
                              <input
                                class="form-control ct_input ct_ff_roboto"
                                placeholder="Enter new password"
                                type={eyes.eye2 ? "text" : "password"}
                                id="newPassword"
                                value={values?.newPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <i
                                style={{ cursor: "pointer" }}
                                class={`fa-regular ct_eye_top ${
                                  eyes.eye2 ? "fa-eye" : "fa-eye-slash"
                                } ct_hide_pass_eye`}
                                onClick={() =>
                                  setEyes({ ...eyes, eye2: !eyes.eye2 })
                                }
                              ></i>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="newPassword"
                            />
                          </div>
                          <div class="form-group">
                            <label
                              for=""
                              class="d-flex align-items-center justify-content-between mb-2"
                            >
                              <span class="ct_fw_600 ">Confirm Password</span>
                            </label>
                            <div class="position-relative">
                              <input
                                class="form-control ct_input ct_ff_roboto"
                                placeholder="Enter confirm password"
                                type={eyes.eye3 ? "text" : "password"}
                                value={values?.confirmPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                autocomplete="off"
                                id="confirmPassword"
                              />
                              <i
                                style={{ cursor: "pointer" }}
                                class={`fa-regular ct_eye_top ${
                                  eyes.eye3 ? "fa-eye" : "fa-eye-slash"
                                } ct_hide_pass_eye`}
                                onClick={() =>
                                  setEyes({ ...eyes, eye3: !eyes.eye3 })
                                }
                              ></i>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="confirmPassword"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-4">
                        <button
                         class="ct_orange_btn px-5"
                         onClick={handleSubmit}
                         >Save</button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ChangePassword;
